import React from 'react';
import { IconBase, IconProps } from '../IconBase';

export const EditedTargetIcon = ({ size, color, title, onClick, decorative, ...restItems }: IconProps) => (
	<IconBase
		viewBox="0 0 52 46"
		size={size}
		color={color}
		title={title}
		onClick={onClick}
		decorative={decorative}
		{...restItems}
	>
		<g filter="url(#filter0_dd_1817_68135)">
			<path
				d="M6 22C6 10.9543 14.9543 2 26 2C37.0457 2 46 10.9543 46 22C46 33.0457 37.0457 42 26 42C14.9543 42 6 33.0457 6 22Z"
				fill="#7A7977"
			/>
			<path
				d="M19.125 25.2812C19.25 24.8438 19.5 24.4375 19.8125 24.125L29.3125 14.625C30.0938 13.8438 31.375 13.8438 32.1562 14.625L33.375 15.8438C33.4688 15.9375 33.5625 16.0625 33.625 16.1562C34.1562 16.9375 34.0625 18 33.375 18.6875L23.875 28.1875C23.8438 28.2188 23.7812 28.25 23.75 28.3125C23.4375 28.5625 23.0938 28.75 22.7188 28.875L20.2812 29.5938L18.9375 30C18.6875 30.0625 18.4062 30 18.2188 29.7812C18 29.5938 17.9375 29.3125 18.0312 29.0625L18.4062 27.7188L19.125 25.2812ZM20.5625 25.7188L20.3438 26.4375L19.8438 28.1562L21.5625 27.6562L22.2812 27.4375C22.5 27.375 22.6562 27.2812 22.8125 27.125L29.9688 19.9688L28.0312 18.0312L20.875 25.1875C20.8438 25.1875 20.8438 25.2188 20.8125 25.25C20.6875 25.375 20.625 25.5312 20.5625 25.7188Z"
				fill="white"
			/>
		</g>
		<defs>
			<filter
				id="filter0_dd_1817_68135"
				x="0"
				y="0"
				width="52"
				height="52"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1817_68135" />
				<feOffset dy="2" />
				<feGaussianBlur stdDeviation="2" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1817_68135" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1817_68135" />
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="4" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_1817_68135" result="effect2_dropShadow_1817_68135" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1817_68135" result="shape" />
			</filter>
		</defs>
	</IconBase>
);
